import React from 'react';

function getSelectedValue(options) {
  const date = options.target.value;

  return date;
}

const FilterDate = ({ onChange, filter }) => {
  var value = filter ? filter.value : '';

  return (
    <input
      type="date"
      value={value}
      onChange={selected => onChange(getSelectedValue(selected))}
      id="date"
    />
  );
};

export default FilterDate;
